<h1 class="text-gray-900 text-3xl text-center font-bold">Tire Comparison Results</h1>

<app-hr class="mt-2"></app-hr>
